import { type HierarchicalLogger } from '@atlassian/logger-interface';
import { type Entity } from '@post-office/tap-client';
import { type CachedTapClient } from '../../clients/tap-client';

export interface SiteUserRequestParams {
	resourceIds: string[];
}

export interface TapProviderParams {
	cachedTapClient: CachedTapClient;
	logger: HierarchicalLogger;
	requester: string;
}

/*
 * This function is called via your TapProvider.
 *
 * When it is called, you will provide a list of SITE USER Aris
 * The TapProvider will then call this helper function, and supplement it with the TapProvider & logger.
 *
 * Note: An audience is a type of trait. This returns all traits & audiences for a list of site users.
 *
 * @param siteUserRequestParams - a list of SITE USER Aris to get the Site User Traits for.
 * @param tapProviderParams - The tap provider parameters. This includes the tapProvider & logger.
 * @returns A list of Site User Traits or undefined if there is an error
 */
export async function getSiteUserTraitsHelper(
	{ resourceIds }: SiteUserRequestParams,
	{ cachedTapClient, logger, requester }: TapProviderParams,
): Promise<Entity[] | undefined> {
	try {
		const response = await cachedTapClient.postForSiteUserTraitsShortCache({
			requester,
			resourceIds,
		});
		return response.data?.entities;
	} catch (error) {
		logger.error({ error: error }, 'Error occurred when retrieving EP Site User Traits');
		return undefined;
	}
}
